export const POST_RESET_STATE = 'POST_RESET_STATE';
export const POST_CURRENT_ITEM = 'POST_CURRENT_ITEM';
 
export const POST_REQUEST_LOADING = 'POST_REQUEST_LOADING';
export const POST_REQUEST_SUCCESS = 'POST_REQUEST_SUCCESS';
export const POST_REQUEST_FAILED = 'POST_REQUEST_FAILED';
 
export const POST_CURRENT_ACTION = 'POST_CURRENT_ACTION';
export const POST_RESET_ACTION = 'POST_RESET_ACTION';